'use client';

import { c as _c } from "react/compiler-runtime";
import IconSend from '@/components/assets/icon_send.svg';
import SignInConfirmModal from '@/components/SignInConfirmModal';
import ViverseIconButton, { ViverseIconButtonSize } from '@/components/ViverseIconButton';
import { useAuthContext } from '@/context/AuthContext';
import { useVideoCommentsPanelContext } from '@/context/VideoCommentsPanelContext';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
import { ChangeEvent, useState } from 'react';
import TextareaAutosize, { TextareaAutosizeProps } from 'react-textarea-autosize';
import { useIsClient, useMediaQuery } from 'usehooks-ts';
type CommentTextareaProps = TextareaAutosizeProps & {
  textAreaElementId: string;
  value: string;
  disabled?: boolean;
  submitButtonSize?: ViverseIconButtonSize;
  containerClassName?: string;
  onSubmit?: () => void;
};
function CommentTextarea(t0) {
  const $ = _c(53);
  let className;
  let containerClassName;
  let disabled;
  let onChange;
  let onSubmit;
  let props;
  let submitButtonSize;
  let textAreaElementId;
  let value;
  if ($[0] !== t0) {
    ({
      textAreaElementId,
      value,
      disabled,
      submitButtonSize,
      className,
      containerClassName,
      onChange,
      onSubmit,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = containerClassName;
    $[3] = disabled;
    $[4] = onChange;
    $[5] = onSubmit;
    $[6] = props;
    $[7] = submitButtonSize;
    $[8] = textAreaElementId;
    $[9] = value;
  } else {
    className = $[1];
    containerClassName = $[2];
    disabled = $[3];
    onChange = $[4];
    onSubmit = $[5];
    props = $[6];
    submitButtonSize = $[7];
    textAreaElementId = $[8];
    value = $[9];
  }
  const t = useTranslations();
  const isTablet = useMediaQuery("(min-width: 768px)");
  const {
    isSignedIn
  } = useAuthContext();
  const {
    panelHostEl
  } = useVideoCommentsPanelContext();
  const [showSignInModal, setShowSignInModal] = useState(false);
  const isClient = useIsClient();
  const isClientSignIn = isClient && isSignedIn;
  let t1;
  if ($[10] !== onChange) {
    t1 = e => {
      onChange?.(e);
    };
    $[10] = onChange;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  const handleChange = t1;
  let t2;
  if ($[12] !== disabled || $[13] !== onSubmit || $[14] !== value) {
    t2 = e_0 => {
      if (e_0.key === "Enter" && (e_0.metaKey || e_0.ctrlKey)) {
        e_0.preventDefault();
        if (onSubmit && value.trim() && !disabled) {
          onSubmit();
        }
      }
    };
    $[12] = disabled;
    $[13] = onSubmit;
    $[14] = value;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  const handleKeyDown = t2;
  let t3;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setShowSignInModal(false);
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t) {
    t4 = t("sign-in-confirm-modal.description");
    $[17] = t;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== panelHostEl || $[20] !== showSignInModal || $[21] !== t4) {
    t5 = <SignInConfirmModal open={showSignInModal} onClose={t3} content={t4} container={panelHostEl} />;
    $[19] = panelHostEl;
    $[20] = showSignInModal;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== containerClassName) {
    t6 = cn("relative flex min-h-[34px] w-full items-center gap-2", containerClassName);
    $[23] = containerClassName;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t) {
    t7 = t("comment-field.placeholder");
    $[25] = t;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  const t8 = isTablet ? undefined : 5;
  let t9;
  if ($[27] !== className) {
    t9 = cn("bg-vive-primary-70 disabled:bg-vive-primary-80 disabled:placeholder:text-vive-primary-60 hover:bg-vive-primary-60 text-vive-primary-20 hover:text-vive-white focus:outline-vive-brand-50! placeholder:text-vive-primary-30 size-full resize-none rounded-[3px] px-4 py-[5px] outline-transparent focus:placeholder:text-transparent focus-visible:outline-2", className);
    $[27] = className;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  const t10 = !isClientSignIn || disabled;
  let t11;
  if ($[29] !== handleChange || $[30] !== handleKeyDown || $[31] !== props || $[32] !== t10 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9 || $[36] !== textAreaElementId || $[37] !== value) {
    t11 = <TextareaAutosize id={textAreaElementId} value={value} placeholder={t7} maxRows={t8} className={t9} onChange={handleChange} onKeyDown={handleKeyDown} disabled={t10} {...props} />;
    $[29] = handleChange;
    $[30] = handleKeyDown;
    $[31] = props;
    $[32] = t10;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
    $[36] = textAreaElementId;
    $[37] = value;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== disabled || $[40] !== isClientSignIn || $[41] !== onSubmit || $[42] !== submitButtonSize || $[43] !== t || $[44] !== value) {
    t12 = isClientSignIn ? <div className="flex h-full flex-col justify-end"><ViverseIconButton size={submitButtonSize} variant="empty" onClick={onSubmit} disabled={disabled || !value.trim()}><IconSend className="fill-vive-primary-20 group-hover:fill-vive-white group-active:fill-vive-primary-40 size-5 md:size-6" /></ViverseIconButton></div> : <span onClick={() => setShowSignInModal(true)} className="text-primary tracking=[0.15px] hover:text-vive-brand-40 active:text-vive-brand-60 absolute right-7 cursor-pointer text-xs leading-5.5 font-semibold md:text-sm">{t("comment-textarea.sign-in")}</span>;
    $[39] = disabled;
    $[40] = isClientSignIn;
    $[41] = onSubmit;
    $[42] = submitButtonSize;
    $[43] = t;
    $[44] = value;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  let t13;
  if ($[46] !== t11 || $[47] !== t12 || $[48] !== t6) {
    t13 = <div className={t6}>{t11}{t12}</div>;
    $[46] = t11;
    $[47] = t12;
    $[48] = t6;
    $[49] = t13;
  } else {
    t13 = $[49];
  }
  let t14;
  if ($[50] !== t13 || $[51] !== t5) {
    t14 = <>{t5}{t13}</>;
    $[50] = t13;
    $[51] = t5;
    $[52] = t14;
  } else {
    t14 = $[52];
  }
  return t14;
}
export default CommentTextarea;